import { getCountryByCountryCode } from 'helpers/postOffice/postOffice';
import { PickupPointType } from 'types/pickupPoint';

export type PplExtendedPoint = {
    code?: string | null;
    name?: string | null;
    additionalNote?: string | null;
    address?: {
        street?: string | null;
        city?: string | null;
        zipCode?: string | null;
        countryCode?: string | null;
        gps?: {
            lat?: number | null;
            lon?: number | null;
        } | null;
    } | null;
    openHours?: any | null;
    activeFeatures?: {
        vacationMode?: boolean | null;
    } | null;
    paymentMethods?: {
        onlineRequired?: boolean | null;
    } | null;
};

export function mapPplExtendedPoint(point: PplExtendedPoint): PickupPointType {
    return {
        identifier: point.code ?? '',
        name: point.name ?? '',
        email: null,
        telephone: null,
        description: point.additionalNote ?? '',
        openingHours: point.openHours ?? null,
        street: point.address?.street ?? '',
        postcode: point.address?.zipCode ?? '',
        city: point.address?.city ?? '',
        country: getCountryByCountryCode(point.address?.countryCode || ''),
        disabled: Boolean(point.activeFeatures?.vacationMode),
        reservationDisabled: Boolean(point.paymentMethods?.onlineRequired),
        locationLatitude: point.address?.gps?.lat ? String(point.address.gps.lat) : null,
        locationLongitude: point.address?.gps?.lon ? String(point.address.gps.lon) : null,
    };
}
